import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, throwError } from 'rxjs';
import { CHANNEL_ATRIL_PANTALLA_NAME, END_EXPERIENCE_EVENT, SHOW_SAY_GOOD_BYE_VIEW_EVENT } from 'src/app/fitur-26/pages/home/config';
import { WebsocketLaravelReverb } from 'src/app/fitur-26/pages/home/services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SendSayGoodByeEmail {
  private _http = inject(HttpClient);
  private _router = inject(Router);
  private _websocketLaravelReverbService = inject(WebsocketLaravelReverb);

  private _isLoadingSendGoodByeEmail = signal<boolean>(false);
  public isLoadingSendGoodByeEmail = this._isLoadingSendGoodByeEmail.asReadonly();
  
  private _setTimeOutId: ReturnType<typeof setTimeout>;
  
  public setIsLoadingSendGoodByeEmail(value: boolean): void {
    this._isLoadingSendGoodByeEmail.set(value);
  }
  
  sendSayGoodByeEmail(token: string): Observable<any> {
    this._isLoadingSendGoodByeEmail.set(true);
    
    const url = environment.apiUrlBase + '/api/fitur/send-final-email'
    return this._http.post<any>(url, { token: token }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching suggestion list:', error);
        return throwError(() => error);
      }),
      map((response: any) => {
        console.log('Response from sendSayGoodByeEmail:', response);
        this._setTimeOutId = setTimeout(() => {
          this.sendEndExperienceByWS(token);
          this._router.navigate(['/']);
        }, 7000);
      }),
    );  
  }
  
  public clearTimeoutSendGoodBye(): void {
    if (this._setTimeOutId) {
      clearTimeout(this._setTimeOutId);
      this._setTimeOutId = undefined;
    }
  }
  
  public sendMessageSayGoodByeByWS(token: string): void {
    this._websocketLaravelReverbService.sendMessage(
      CHANNEL_ATRIL_PANTALLA_NAME, 
      SHOW_SAY_GOOD_BYE_VIEW_EVENT + token, 
      []
    );
  }
  
  public sendEndExperienceByWS(token: string): void {
    this._websocketLaravelReverbService.sendMessage(
      CHANNEL_ATRIL_PANTALLA_NAME, 
      END_EXPERIENCE_EVENT + token, 
      []
    );
  }
}
